import { Component, EventEmitter, Input, Output , AfterViewInit} from '@angular/core'
import { AccountTypes, PaymentAccount } from '../../models/payment-account'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'PaymentAccountForm',
    templateUrl: './payment-account-form.component.html'
})
export class PaymentAccountFormComponent implements AfterViewInit {
    @Input() disabled: boolean = false
    @Input() paymentAccount: PaymentAccount = {} as PaymentAccount
    @Output() onValueChange: EventEmitter<PaymentAccount> = new EventEmitter<PaymentAccount>()
    enrollModel: EnrollmentViewModel = {} as EnrollmentViewModel

    accountTypeOptions: ValidatedRadioButtonModel[] = Object.keys(AccountTypes).map((accountTypeKey) => {
        return { value: accountTypeKey, htmlLabel: AccountTypes[accountTypeKey] }
    })

    routingNumberLengthValidator: LengthTextFieldValidator = new LengthTextFieldValidator(9)
    notBlankValidator: NotBlankGenericFieldValidator = new NotBlankGenericFieldValidator()
    numericValidator: NumericTextFieldValidator = new NumericTextFieldValidator()
    orgName: string

    //change(paymentAccount: any) {
    //    Object.assign(this.enrollment.paymentAccount, paymentAccount)
    //    this.onValueChange.emit(this.enrollment.paymentAccount)
    //}

    constructor(
        private _enrolservice: EnrollmentGateway,
        public _global: PortalGlobals) {

        this.orgName = _global.currentUser.insuranceCompanyName
        
    }

    ngAfterViewInit(): void {
        this.enrollModel = this._enrolservice.getEnrollmentViewModel()
        if (this.enrollModel.paymentAccount !== undefined) {
            this.paymentAccount = this.enrollModel.paymentAccount
        }
    }
    updateInfo(fieldName: string, fieldValue: string) {
        this.paymentAccount[fieldName] = fieldValue
        this.onValueChange.emit(this.paymentAccount)
    }
}